import { createAsyncThunk } from "@reduxjs/toolkit";
import { ThunkApiConfig } from "@shared/models/redux";
import { UserRole } from "@myProfile/models";

/**
 * Fetches user roles from the Snowflake data API based on sfdcContactId
 *
 * API Endpoint: GET /contacts/v1/system/SnowflakeData/role/{contactId}
 * Response: Array of UserRole objects, e.g., [{ roleName: "Primary Contact" }, { roleName: "Tax Advisor" }]
 */
export const fetchUserRolesThunk = createAsyncThunk<UserRole[], string, ThunkApiConfig>(
  "myProfile/fetchUserRoles",
  async (sfdcContactId, { extra, rejectWithValue }) => {
    try {
      const url = `/contacts/v1/system/SnowflakeData/role/${sfdcContactId}`;

      const response = await extra<UserRole[]>(url, {
        method: "GET",
      });

      return response.data;
    } catch (error) {
      console.error("[fetchUserRoles] Error fetching user roles:", error);

      return rejectWithValue("Failed to fetch user roles");
    }
  }
);
